import React from 'react';
import {createRoot} from "react-dom/client";
import {AuthProvider} from "./auth/app.auth.main";
import {Router} from "react-router";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import AppAuthLoginFormModalPage from "./auth/app.auth.loginform.modalpage";


const AppAuthPage = () => {

    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<AppAuthLoginFormModalPage/>} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    )
}

const el = document.getElementById('show_auth_page');
if(el){
    const root = createRoot(el);
    root.render(<AppAuthPage/>);
}
